import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from '../../shared/services/notification.service';
import { PasswordRecoveryService } from './services/password-recovery.service';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
  standalone: false,
})
export class PasswordRecoveryComponent {
  resetEnabled = false;

  // Typed form control to keep things consistent
  userForm = new FormGroup({
    user: new FormControl<string | null>('', Validators.required),
  });

  constructor(
    private passRecoveryService: PasswordRecoveryService,
    private router: Router,
    private notificationService: NotificationService,
  ) {}

  /** Getter for the 'user' control */
  get user(): FormControl<string | null> {
    return this.userForm.get('user') as FormControl<string | null>;
  }

  /** Strict boolean return for template bindings */
  enableReset(): boolean {
    return !!this.user?.valid;
  }

  /** Original logic preserved: call service, show translated messages, then navigate */
  resetPassword(): void {
    if (this.user?.valid) {
      const userValue = this.user.value;
      if (userValue) {
        this.passRecoveryService.recoverPassword(userValue).subscribe({
          next: () => {
            // Success: show snackbar and navigate home
            this.notificationService.showSnack('PASS_RECOVERY_SUCCESS', 3000);
            this.router.navigate(['/']);
          },
          error: () => {
            // Error: open translated dialog
            this.notificationService.showDialog('RECOVER_ERR_MESSAGE');
          },
        });
      }
    }
  }
}
